export const recordsPerPage = 10



// WEBPACK FOOTER //
// ./src/types/settings.ts